export class BookingBase{
    public id: string;
    public organizationId: string;
    public lastEditedBy: string;
}